import React from "react";
import { MainLeftTitle } from "../../_uiComponents/WrapperComponents";
import Reports from "./Reports";

export function ReportsWrapper(props) {
     return (
          <>
               <MainLeftTitle title="Management Reports" />
               <Reports />
          </>
     );
}
